import React from 'react';

const Image = ({ src }) => {
  let imageStyle = {
    minWidth: 100 + '%',
    height: '320px',
  };
  return <img src={src} alt="slide-pict" style={imageStyle} />;
};

export default Image;
